import React, { useEffect, useState } from "react";
import BannerCard from "./BannerCard";
import "./BannerCarousel.css";
import { getBanners, getBannerPath, getBannerObject } from "./ParseBannersService"
import { Loading } from '../Loading/Loading';

export default function BannerCarousel({
    context,
    visibleItems = 1,
    onBannerClick
}) {

    const [currentPage, setCurrentPage] = useState(0);
    const [banners, setBanners] = useState([]);

    const [bannerCarousel, setBannerCarousel] = useState([])
    const [loading, setLoading] = useState(false);

    const totalPages = Math.ceil(bannerCarousel.length / visibleItems);

    const startIndex = currentPage * visibleItems;

    const visibleBanners = bannerCarousel.slice(
        startIndex,
        startIndex + visibleItems
    );

    useEffect(() => {
        getBannersData();
    }, []);

    useEffect(() => {
        makeRequest();
    }, [banners]);

    function next() {
        if (currentPage < totalPages - 1) {
            setCurrentPage(currentPage + 1);
        }
    }

    const getBannersData = async () => {
        setLoading(true);
        try {
            const { idToken } = context;

            const headers = {
                Authorization: `Bearer ${idToken}`
            };

            const response = await fetch("/Banners/GetBanners", { headers });

            if (!response.ok) {
                setBanners([]);
                return;
            }

            const data = await response.json();
            const dataJson = JSON.parse(data.bannersContent);
            const bannersList = getBanners(dataJson);
            const banners = bannersList.map((banner) => (
                { ...banner, path: getBannerPath(banner) }
            ));

            setBanners(banners);

        } catch (error) {
            console.error("Error fetching protection data:", error);
            setBanners([]);
        } finally {
            setLoading(false);
        }
    }

    const getBannerCarousel = async (path) => {
        try {
            const { idToken } = context;

            const headers = {
                Authorization: `Bearer ${idToken}`
            };

            const requestUrl = `/Banners/GetBanner?path=${path}`;
            const response = await fetch(requestUrl, { headers });

            if (!response.ok) {
                return;
            }

            const data = await response.json();
            const dataJson = JSON.parse(data.bannersContent);
            const bannerObject = getBannerObject(dataJson);
            return bannerObject;

        } catch (error) {
            console.error("Error fetching protection data:", error);
        } finally {
            console.log("Request: ", path);
        }
    }

    const makeRequest = async () => {

        try {
            const result = await Promise.all(
                banners.map(async (item) => {
                    console.log("1 ", item.path);
                    const response = await getBannerCarousel(item.path);

                    if (!response.ok) {
                        throw new Error(`Erro na chamada: ${item.url}`);
                    }

                    return response.json();
                })
            );
            console.log("2 ", result);
            setBannerCarousel(result);
        } catch (error) {
            console.error("Erro ao executar as chamadas:", error);
        } finally {
            setLoading(false);
        }
    }

    function previous() {
        if (currentPage > 0) {
            setCurrentPage(currentPage - 1);
        }
    }

    return (
        <div className="banner-carousel-container">
            {loading ? (
                <Loading />
            ) : (
                <>
                    <span className="banner-carousel-title">Mais para si</span>
                    <div className="banner-carousel">
                        <div className="banner-carousel__content">
                            {visibleBanners.map((banner) => (
                                <BannerCard
                                    key={banner.url}
                                    banner={banner}
                                    onClick={() => onBannerClick?.(banner)}
                                />
                            ))}
                        </div>
                        <div className="banner-carousel__navigation">
                            <button
                                disabled={currentPage === 0}
                                onClick={previous}
                            >
                                ←
                            </button>
                            <button
                                disabled={currentPage === totalPages - 1}
                                onClick={next}
                            >
                                →
                            </button>
                        </div>
                    </div>
                </>
            )}
        </div>
    );

}